export interface RateMenuModel {
  "rate": number,
  "service": string,
  "supplier_id": string,
  "comment": string,
  "user_name": string,
  "user_phone": number,
  "user_email": string
}

export enum dataNameRate {
  RATENPS = "rateNps",
  RATEDIGITAL = "rateDigital"
};

export const RATE_SERVICE = {
  [dataNameRate.RATENPS]: "nps",
  [dataNameRate.RATEDIGITAL]: "digita_menu",
} as const;

export type RateServices = 'rateNps' | 'rateDigital';
